import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8bda704a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "field" }
const _hoisted_3 = {
  key: 0,
  class: "field-title"
}
const _hoisted_4 = ["placeholder"]

import { CoercableComponent } from "features/feature";
import { coerceComponent } from "util/vue";
import { computed, onMounted, ref, toRefs, unref } from "vue";
import VueTextareaAutosize from "vue-textarea-autosize";
import "components/common/fields.css";


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    modelValue: null,
    textArea: { type: Boolean },
    placeholder: null,
    maxHeight: null
  },
  emits: ["update:modelValue", "submit"],
  setup(__props: any, { emit }: { emit: ({
    (e: "update:modelValue", value: string): void;
    (e: "submit"): void;
}), expose: any, slots: any, attrs: any }) {

const _props = __props as {
    title?: CoercableComponent;
    modelValue?: string;
    textArea?: boolean;
    placeholder?: string;
    maxHeight?: number;
}


const props = toRefs(_props);


const titleComponent = computed(
    () => props.title?.value && coerceComponent(unref(props.title.value), "span")
);

const field = ref<HTMLElement | null>(null);
onMounted(() => {
    field.value?.focus();
});

const value = computed({
    get() {
        return unref(props.modelValue) || "";
    },
    set(value: string) {
        emit("update:modelValue", value);
    }
});

function submit() {
    emit("submit");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(submit, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(titleComponent))
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(titleComponent))))
          ]))
        : _createCommentVNode("", true),
      (__props.textArea)
        ? (_openBlock(), _createBlock(_unref(VueTextareaAutosize), {
            key: 1,
            modelValue: _unref(value),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
            placeholder: __props.placeholder,
            maxHeight: __props.maxHeight,
            onBlur: submit,
            ref_key: "field",
            ref: field
          }, null, 8, ["modelValue", "placeholder", "maxHeight"]))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 2,
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
            placeholder: __props.placeholder,
            class: _normalizeClass({ fullWidth: !__props.title }),
            onBlur: submit,
            ref_key: "field",
            ref: field
          }, null, 42, _hoisted_4)), [
            [_vModelText, _unref(value)]
          ])
    ])
  ], 40, _hoisted_1))
}
}

})